import { useSession } from '@/contexts/SessionProvider'
import { hasPermission } from '@/lib/auth/permissions'
import type { IPermission } from '@/types/permissions'

export default function useHasPermission(permission: IPermission): boolean {
  const session = useSession()
  return hasPermission({ user: session.user, permission })
}
